module.exports = __webpack_public_path__ + "static/media/philips.bc8fc6c3.svg";